import { useEffect, useState } from "react";

// What counts as the visitor interacting with the page, on desktop and mobile.
// Also used by afterInteractionOrDelay (utils/afterPageLoad.ts).
export const INTERACTION_EVENTS = [
  "pointerdown",
  "touchstart",
  "click",
  "keydown",
  "scroll",
  "wheel",
] as const;

export const useInteract = () => {
  const [interacted, setInteracted] = useState(false);
  useEffect(() => {
    const onInteract = () => {
      setInteracted(true);
    };

    for (const event of INTERACTION_EVENTS) {
      window.addEventListener(event, onInteract, { passive: true });
    }

    return () => {
      for (const event of INTERACTION_EVENTS) {
        window.removeEventListener(event, onInteract);
      }
    };
  }, []);
  return interacted;
};
